import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface Props {
  targetQueryName?: string;
  children: React.ReactNode;
}

export const Portal = ({ targetQueryName = '#__next', children }: Props) => {
  const [rootEl, setRootEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const root = document.querySelector(targetQueryName) as HTMLElement;
    setRootEl(root);
  }, []);

  return rootEl && ReactDOM.createPortal(children, rootEl);
};
